module.exports = __webpack_public_path__ + "img/banner01-desktop-v2.070e6130.webp";